import type { ComponentType, ReactNode } from "react"

/** Application UI "empty state with dashed border": an icon, a line of copy, and a call to action. */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
}: {
  icon: ComponentType<{ className?: string }>
  title: string
  description?: string
  action?: ReactNode
}) {
  return (
    <div className="rounded-xl border-2 border-dashed border-hairline p-12 text-center">
      <Icon className="mx-auto size-10 text-ink-muted" />
      <h3 className="mt-3 text-sm/6 font-semibold text-ink-display">{title}</h3>
      {description && <p className="mx-auto mt-1 max-w-md text-sm/6 text-ink-muted">{description}</p>}
      {action && <div className="mt-6 flex justify-center">{action}</div>}
    </div>
  )
}
